import _styled from "styled-components";
const _excluded = ["children", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import theme from '@adsk/alloy-react-theme';
import { useTranslation } from '../../i18n';
const Placeholder = _ref => {
  let {
      children,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    t
  } = useTranslation();
  const placeholder = children || t('SELECT');
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, props, {
    $_css: [theme.typography.labelMedium, theme.typography.ellipsis, {
      color: theme.tokens.colors.text.tertiary.value,
      pointerEvents: 'none',
      userSelect: 'none',
      flex: 1
    }, style]
  }), placeholder);
};
export default Placeholder;
var _StyledDiv = _styled("div").withConfig({
  displayName: "Placeholder___StyledDiv",
  componentId: "sc-1rldc3a-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=Placeholder.js.map